import Plotly from 'plotly.js-dist-min';

// Default: show chart-relevant options on hover
export const CHART_RELEVANT_PLOTLY_CONFIG: Partial<Plotly.Config> = {
  displaylogo: false,
  displayModeBar: 'hover',
  responsive: true,
  modeBarButtonsToRemove: [
    'zoom2d',
    'select2d',
    'lasso2d',
    'toggleSpikelines',
    'hoverCompareCartesian',
    'hoverClosestCartesian',
  ] as Plotly.ModeBarDefaultButtons[],
};

// Override: hide toolbar completely for display-only charts
export const CHART_NO_TOOLBAR_CONFIG: Partial<Plotly.Config> = {
  ...CHART_RELEVANT_PLOTLY_CONFIG,
  displayModeBar: false,
};